import { FiCalendar, FiFileText, FiAlertCircle } from 'react-icons/fi'
import '../../style/components/ChatHero.css'

type HeroProps = {
  onSuggestionClick: (suggestion: string) => void
}

const suggestions = [
  { text: "What's on my schedule today?", icon: <FiCalendar /> },
  { text: "Summarize my last meeting", icon: <FiFileText /> },
  { text: "Show my overdue action items", icon: <FiAlertCircle /> }
]

const Hero = ({ onSuggestionClick }: HeroProps) => {
  return (
    <div className="chat-hero">
      <div className="hero-content">
        <div className="hero-logo-wrap">
           <div className="hero-logo">B</div>
           <div className="hero-logo-ripple" />
        </div>
        <h1 className="hero-title">How can I help you today?</h1>
        <p className="hero-subtitle">Ask me about your contacts, meetings, or action items.</p>
        
        <div className="hero-suggestions">
          {suggestions.map((s, pos) => (
            <button type="button"
              key={s.text}
              className="suggestion-chip"
              onClick={() => onSuggestionClick(s.text)}
              style={{ animationDelay: `${pos * 100 + 400}ms` }}
            >
              <span className="suggestion-icon">{s.icon}</span>
              <span className="suggestion-text">{s.text}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Hero
